import { mdiCalendarClockOutline } from "@mdi/js"
import type { AdminQuickLink } from "@kontextwerk/control-web-frame/shared/logic/admin-links"
import {
  buildRichTooltip,
  RICH_TOOLTIP_CLASS,
  tooltipField,
  tooltipTitle,
} from "../../../_shared/_logic/rich-tooltips"

const terminportalTooltip = "Öffnet das Terminportal für Ihre Kunden in einem neuen Tab."

export const buildTerminportalHref = (
  organizationSlug: string | null | undefined,
): string | null => {
  const normalizedSlug = organizationSlug?.trim()

  return normalizedSlug ? `/presentation/${encodeURIComponent(normalizedSlug)}` : null
}

export const buildTerminportalQuickLink = (
  organizationSlug: string | null | undefined,
): AdminQuickLink | null => {
  const href = buildTerminportalHref(organizationSlug)

  if (!href) return null

  return {
    id: "terminportal",
    label: "Terminportal",
    href,
    iconPath: mdiCalendarClockOutline,
    tooltipContent: terminportalTooltip,
    tooltipClassName: RICH_TOOLTIP_CLASS,
    testIdSuffix: "openTerminportalButton",
  }
}
